import React from "react";
import "./Questions.css"
import "./Commons.css"
import * as RestApi from "./RestApi"
import {checkMikaResponseSuccess} from "./RestApi"
import {InfoListButton} from "./Containers"
import deleteBtnImage from "./Images/delete_icon.png";
import createBtnImage from "./Images/add_icon.png";
import {CancelButton, ConfirmButton} from "./Controllers";

const ELocalizedLanguage = Object.freeze({Unknown: 0, It: 1, En: 2});
const LanguageMappings = ['Unknown', 'It', 'En'];

function getLocalizedText(text, lang) {
    const lang_str = LanguageMappings[lang];
    const ret_loc = text.find(elem => elem.language === lang_str);
    if (ret_loc === undefined) {
        console.warn(`Couldn't find localized text for language ${lang_str} in ${text}`);
        return `Text for language ${lang_str} not found`;
    }
    return ret_loc.text;
}

function setLocalizedText(text, lang, new_loc_text) {
    const lang_str = LanguageMappings[lang];
    const loc_text_index = text.findIndex(elem => elem.language === lang_str);
    if (loc_text_index === -1) {
        console.warn(`Couldn't find localized text for language ${lang_str} in ${text}`);
        return `Language ${lang_str} not found`;
    }
    text[loc_text_index].text = new_loc_text;
    return true;
}

export class QuestionsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {isEditing: false, questions: null, editedQuestion: null};
        this.refreshAvailableQuestions = this.refreshAvailableQuestions.bind(this);
        this.setEditorEnabled = this.setEditorEnabled.bind(this);
    }

    setEditorEnabled(enabled, question) {
        this.setState({isEditing: enabled, editedQuestion: (enabled ? question : null)});
        if (!enabled)
            this.refreshAvailableQuestions();
    }

    async componentDidMount() {
        await this.refreshAvailableQuestions();
    }

    async refreshAvailableQuestions() {
        const resp = await RestApi.getUpdatedQuestions();
        if (await checkMikaResponseSuccess(resp))
            this.setState({questions: resp.questions});
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.refreshQuestions)
            await this.refreshAvailableQuestions();
    }

    render() {
        let questions_list;
        if (this.state.questions)
            questions_list = this.state.questions.map(question => <QuestionListItem key={question.id}
                                                                                    question={question}
                                                                                    onClick={this.setEditorEnabled.bind(null, true, question)}
                                                                                    refreshDelegate={this.refreshAvailableQuestions}
                                                                                    info={`${question.category} - ${getLocalizedText(question.text, ELocalizedLanguage.It)}`}/>);
        if (this.state.isEditing)
            return (
                <div className="QuestionsContainer">
                    <QuestionEditorPanel question={this.state.editedQuestion} setEditorEnabled={this.setEditorEnabled}/>
                </div>
            );
        else return (
            <div className="QuestionsContainer">
                <div className="ViewListHeader">
                    <div>Info Domanda</div>
                    <div>Elimina<br/>domanda</div>
                </div>
                {questions_list}
                <CreateNewQuestionButton refreshDelegate={this.refreshAvailableQuestions}/>
            </div>
        );
    }
}

export function QuestionListItem(props) {
    let question = props.question;
    return (
        <div className="ViewListItemWideFlex">
            <InfoListButton onClick={props.onClick} info={props.info}/>
            <DeleteQuestionButton refreshDelegate={props.refreshDelegate} qId={question.id}/>
        </div>
    );
}

export function CreateNewQuestionButton(props) {
    async function createQuestion() {
        const question_text = window.prompt("Testo domanda (italiano):");
        if (question_text != null) {
            let question = {};
            question.id = ""; // A unique ID will be given by the server, but the field needs to be there in the first place.
            question.text = [{text: question_text, language: 'It'}, {text: "", language: "En"}];
            question.category = "Free";
            question.options = [];
            const resp = await RestApi.addQuestion(question);
            if (await checkMikaResponseSuccess(resp))
                props.refreshDelegate();
        }
    }

    return (
        <div className="newListItemContainer">
            <div>Aggiungi Domanda</div>
            <button className="CreateNewListItemButton" onClick={createQuestion}>
                <img alt="Create Question" src={createBtnImage} className="imgFitParent"/>
            </button>
        </div>
    )
}

export function DeleteQuestionButton(props) {
    async function deleteQuestion() {
        const confirmation = window.confirm("Confermi eliminazione?");
        if (confirmation) {
            const resp = await RestApi.removeQuestion(props.qId);
            await checkMikaResponseSuccess(resp);
            await props.refreshDelegate();
        }
    }

    return (
        <button className="DeleteListItemButton" onClick={deleteQuestion}>
            <img alt="Delete Question" className="imgFitParent" src={deleteBtnImage}/>
        </button>);
}

export class QuestionEditorPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            question: props.question,
            questionCategory: props.question.category,
            qOptions: props.question.options,
            editLanguage: ELocalizedLanguage.It
        };
        this.questionUpdateCancel = this.questionUpdateCancel.bind(this);
        this.questionUpdateConfirm = this.questionUpdateConfirm.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.addNewOption = this.addNewOption.bind(this);
        this.changeEditLanguage = this.changeEditLanguage.bind(this);
    }

    changeEditLanguage(lang) {
        this.setState({editLanguage: lang});
    }

    handleInputChange(event) {
        const target = event.target;
        let value;
        switch (target.name) {
            case "questionText": {
                value = target.value;
                let quest = this.state.question;
                setLocalizedText(quest.text, this.state.editLanguage, value);
                this.setState({question: quest});
                break;
            }
            case "questionCategory":
            default: {
                value = target.value;
                this.setState({[target.name]: value});
            }
        }
    }

    handleOptionChange(index, text, isCorrect) {
        let options = this.state.qOptions;
        setLocalizedText(options[index].text, this.state.editLanguage, text);
        options[index].is_correct = isCorrect;
        this.setState({qOptions: options});
    }

    addNewOption() {
        let qOptions = this.state.qOptions;
        qOptions.push({text: [{text: "Opzione", language: 'It'}, {text: "Option", language: "En"}], is_correct: false});
        this.setState({qOptions: qOptions});
    }

    removeOption(index) {
        let qOptions = this.state.qOptions;
        qOptions.splice(index, 1);
        this.setState({qOptions: qOptions});
    }

    async questionUpdateConfirm() {
        let question = {
            id: this.state.question.id,
            text: this.state.question.text,
            category: this.state.questionCategory,
            options: this.state.qOptions
        };
        const resp = await RestApi.updateQuestion(question);
        if (!await checkMikaResponseSuccess(resp))
            alert("Errore di comunicazione con il server.");
        this.props.setEditorEnabled(false, null);
    }

    questionUpdateCancel() {
        this.props.setEditorEnabled(false, null);
    }

    render() {
        const qOptions = this.state.qOptions;
        const option_items = qOptions.map((opt, i) => <QuestionOptionItem key={i} index={i}
                                                                          editLanguage={this.state.editLanguage}
                                                                          option={opt}
                                                                          removeOption={this.removeOption.bind(this, i)}
                                                                          onOptionChange={this.handleOptionChange.bind(this, i)}/>);
        return (
            <div className="FullSizeFlexRow">
                <div className="QuestionEditorLeftSide">
                    <label className="smallHeader">[ID: {this.state.question.id}]<br/>Testo Domanda:</label>
                    <textarea className="questionTextInput"
                              value={getLocalizedText(this.state.question.text, this.state.editLanguage)}
                              name="questionText"
                              onChange={this.handleInputChange}/>
                    <label className="smallHeader">Categoria:</label>
                    <QuestionCategorySelector name="questionCategory" onChange={this.handleInputChange}
                                              value={this.state.questionCategory}/>
                    <button className="button purple" onClick={this.addNewOption}>Aggiungi Opzione</button>
                    <QuestionLanguageSwitcher changeEditLanguage={this.changeEditLanguage} editLanguage={this.state.editLanguage}/>
                    <div className="confirmCancelBox">
                        <ConfirmButton onClick={this.questionUpdateConfirm}/>
                        <CancelButton onClick={this.questionUpdateCancel}/>
                    </div>
                </div>
                <div className="QuestionEditorRightSide">
                    {option_items}
                </div>
            </div>
        );
    }
}

function QuestionOptionItem(props) {
    function handleIsCorrectChange(event) {
        props.onOptionChange(getLocalizedText(props.option.text, props.editLanguage), !props.option.is_correct);
    }

    function handleTextChange(event) {
        const target = event.target;
        props.onOptionChange(target.value, props.option.is_correct);
    }

    return (
        <div className="QuestionOptionBox">
            <label className="smallHeader">Testo:</label>
            <textarea rows="3" className="optionTextInput" value={getLocalizedText(props.option.text, props.editLanguage)} onChange={handleTextChange}/>
            <label className="smallHeader">Corretta:</label>
            <input checked={props.option.is_correct} type="checkbox" onChange={handleIsCorrectChange}/>
            <button className="DeleteListItemButton" onClick={props.removeOption}>
                <img alt="Delete Option" className="imgFitParent" src={deleteBtnImage}/>
            </button>
        </div>
    );
}

function QuestionCategorySelector(props) {
    const categories = ['Free', 'SalaCapire', 'SalaConoscere', 'SalaRisparmiare', 'SalaSperimentare', 'SalaSognare', 'LusardiMitchell', 'SfidaOlfattiva'].map(cat =>
        <option key={cat} value={cat}>{cat}</option>);
    return (
        <select name={props.name} onChange={props.onChange} className="selectInput" value={props.value}>
            {categories}
        </select>
    );
}

function QuestionLanguageSwitcher(props) {
    function handleOnClick() {
        props.changeEditLanguage(props.editLanguage === ELocalizedLanguage.It ? ELocalizedLanguage.En : ELocalizedLanguage.It);
    }

    return (
        <button className="LanguageSwitchButton" onClick={handleOnClick}>Cambia Lingua</button>
    );
}